import { render, staticRenderFns } from "./staff-announcement-form.vue?vue&type=template&id=b82b6098&"
import script from "./staff-announcement-form.vue?vue&type=script&lang=js&"
export * from "./staff-announcement-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports